import {RouterProvider} from "react-router-dom";
import {router} from "~/router";
import background from '~/img/background.png'
import {useEffect, useState} from "react";
import {authenticate, getAuthUser, getUserSkyfax} from "~/authentication";
import {IJWTPayload} from "~/interfaces/IJWTPayload";

export const App = () => {
    const [authUser, setAuthUser] = useState<boolean|IJWTPayload>(false);

    useEffect(() => {
        const authToken = authenticate();
        if(authToken){
            const user= getAuthUser();
            setAuthUser(user ? user : false);
        }
    }, []);

  return (
      <div>
        <div className="bg-cover min-h-screen bg-fixed" style={{backgroundImage: `url(${background})`}}>
            <RouterProvider router={router}/>
        </div>
      </div>
  );
};